import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthForm from './AuthForm.tsx';
import Dashboard from './Dashboard.tsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthForm />} />
        <Route path="/Dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;